module.exports = __webpack_public_path__ + "static/protectiid-sso-66a43f462d0f6eaf24855c0bb2d40ad5.png";